// =============================================================================
// src/features/analytics/analytics-scope-store.ts - "Fora de escopo" (curadoria).
//
// Ponte entre o botao "Fora de escopo" do card e a mutation do Hasura
// (sl_insert_config_content_relevance_override_one). Complementa o bloqueio de
// AUTOR: existe ruido que a blocklist nao resolve sem perda grave — portal local
// monitorado republicando pauta nacional. Ali o alvo e o CONTEUDO, nao o autor.
//
// Mesmo contrato do analytics-block-store: o composition root registra o
// submitter quando o live esta habilitado; sem submitter (mock/offline) o
// resultado e 'unavailable' e o botao vira toast cosmetico. SRP: registro + despacho.
// =============================================================================

export interface AnalyticsScopeOverrideRequest {
  readonly contentId: string;
  readonly verdict: string;
  readonly reason: string;
}

export type AnalyticsScopeOverrideOutcome = 'saved' | 'failed' | 'unavailable';

type AnalyticsScopeOverrideSubmitter = (
  overrideRequest: AnalyticsScopeOverrideRequest,
) => Promise<void>;

let scopeOverrideSubmitter: AnalyticsScopeOverrideSubmitter | null = null;

/** Registrado pelo main.ts quando o Analytics live esta habilitado. */
export function setAnalyticsScopeOverrideSubmitter(
  submitter: AnalyticsScopeOverrideSubmitter,
): void {
  scopeOverrideSubmitter = submitter;
}

/** Envia o override; nunca lanca (o controller decide o toast pelo outcome). */
export async function submitAnalyticsScopeOverride(
  overrideRequest: AnalyticsScopeOverrideRequest,
): Promise<AnalyticsScopeOverrideOutcome> {
  if (!scopeOverrideSubmitter) return 'unavailable';
  try {
    await scopeOverrideSubmitter(overrideRequest);
    return 'saved';
  } catch {
    return 'failed';
  }
}

export function __resetAnalyticsScopeOverrideForTests(): void {
  scopeOverrideSubmitter = null;
}
